(function closure(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('hfConfig', ['global.namespace'],
      function load(THD) {
        return factory(root, THD);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.data = factory(root, THD);
    /*eslint-enable*/
  }
})(this, function factory() {
  var hfConfig = {};
  var privateMethods = {};

  var enableSignInBubbleDefault = false;
  var currentInstanceDefault = 's';
  var nonSecureHostNameDefault = 'www.homedepot.com';
  var secureHostNameDefault = 'secure2.homedepot.com';
  var storeSearchServiceHostNameDefault = 'www.homedepot.com';
  var flyoutVersionDefault = '6';
  var previewFlagDefault = false;
  var deepLinkUrlDefault = '';
  var undefinedVal = 'undefined';
  var isHomePageDefault = false;
  var isPLPPageDefault = false;

  privateMethods.isGlobalExists = function _isGlobalExists() {
    return (typeof THD_GLOBAL !== undefinedVal);
  };
  privateMethods.enableSignInBubble = function _enableSignInBubble() {
    if (privateMethods.isGlobalExists()) {
      return (typeof THD_GLOBAL.enableSignInBubble !== undefinedVal) ? THD_GLOBAL.enableSignInBubble : enableSignInBubbleDefault;
    }
    return enableSignInBubbleDefault;
  };
  privateMethods.currentInstance = function _currentInstance() {
    if (privateMethods.isGlobalExists()) {
      return (typeof THD_GLOBAL.instance !== undefinedVal) ? THD_GLOBAL.instance : currentInstanceDefault;
    }
    return currentInstanceDefault;
  };
  privateMethods.currentChannel = function _currentChannel() {
    var isMobile = document.querySelectorAll('.footer__help #linkPcSite').length > 0;
    return (isMobile) ? 'mobile' : 'web';
  };
  privateMethods.currentUrl = function _currentUrl() {
    return window.location.href;
  }
  privateMethods.nonSecureHostName = function _nonSecureHostName() {
    if (privateMethods.isGlobalExists()) {
      return (typeof THD_GLOBAL.nonSecureHostName !== undefinedVal) ? THD_GLOBAL.nonSecureHostName : nonSecureHostNameDefault;
    }
    return nonSecureHostNameDefault;
  };
  privateMethods.secureHostName = function _secureHostName() {
    if (privateMethods.isGlobalExists()) {
      return (typeof THD_GLOBAL.secureHostName !== undefinedVal) ? THD_GLOBAL.secureHostName : secureHostNameDefault;
    }
    return secureHostNameDefault;
  };
  privateMethods.storeSearchServiceHostName = function _storeSearchServiceHostName() {
    if (privateMethods.isGlobalExists()) {
      return (typeof THD_GLOBAL.storeSearchServiceHostName !== undefinedVal) ? THD_GLOBAL.storeSearchServiceHostName : storeSearchServiceHostNameDefault;
    }
    return storeSearchServiceHostNameDefault;
  };
  privateMethods.flyoutVersion = function _flyoutVersion() {
    if (privateMethods.isGlobalExists()) {
      return (typeof THD_GLOBAL.flyoutVersion !== undefinedVal) ? THD_GLOBAL.flyoutVersion : flyoutVersionDefault;
    }
    return flyoutVersionDefault;
  };
  privateMethods.previewFlag = function _previewFlag() {
    if (privateMethods.isGlobalExists()) {
      return (typeof THD_GLOBAL.isPv !== undefinedVal) ? THD_GLOBAL.isPv : previewFlagDefault;
    }
    return previewFlagDefault;
  };
  privateMethods.deepLinkUrl = function _deepLinkUrl() {
    if (privateMethods.isGlobalExists()) {
      return (typeof THD_GLOBAL.deepLinkUrl !== undefinedVal) ? THD_GLOBAL.deepLinkUrl : deepLinkUrlDefault;
    }
    return deepLinkUrlDefault;
  };
  privateMethods.isHomePage = function _isHomePage() {
    if (privateMethods.isGlobalExists()) {
      return (typeof THD_GLOBAL.isHomePage !== undefinedVal) ? THD_GLOBAL.isHomePage : isHomePageDefault;
    }
    return isHomePageDefault;
  };
  privateMethods.isPLPPage = function _isPLPPage() {
    if (privateMethods.isGlobalExists()) {
      return (typeof THD_GLOBAL.isPLP !== undefinedVal) ? THD_GLOBAL.isPLP : isPLPPageDefault;
    }
    return isPLPPageDefault;
  };
  privateMethods.isPIPPage = function _isPIPPage() {
    // 1. check for pip
    // 2. check for not pip package
    // 3. check for not pip compare page
    // 4. check for not pip canvas experience
    const { href } = window.location;
    return href.indexOf('/p/') !== -1 &&
      href.indexOf('/p/sets/') === -1 &&
      href.indexOf('/p/compare') === -1 &&
      window.experienceMetadata === undefined;
  };
  hfConfig.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  hfConfig.init = function () {
    return {
      'signInBubble': privateMethods.enableSignInBubble(),
      'currentInstance': privateMethods.currentInstance(),
      'currentChannel': privateMethods.currentChannel(),
      'currentUrl': privateMethods.currentUrl(),
      'nonSecureHostName': privateMethods.nonSecureHostName(),
      'secureHostName': privateMethods.secureHostName(),
      'storeSearchServiceHostName': privateMethods.storeSearchServiceHostName(),
      'flyoutVersion': privateMethods.flyoutVersion(),
      'previewFlag': privateMethods.previewFlag(),
      'deepLinkUrl': privateMethods.deepLinkUrl(),
      'isHomePage': privateMethods.isHomePage(),
      'isPLPPage': privateMethods.isPLPPage(),
      'isPIPPage': privateMethods.isPIPPage(),
      'isGlobal': privateMethods.isGlobalExists(),
      'getPrivate': hfConfig.getPrivateMethods()
    };
  };
  return hfConfig.init();
});